// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + ({"138":"profile","147":"app-routes","251":"checkout","352":"onboarding"}[chunkId] || chunkId) + "." + {"138":"5d0c98de4b4b09cb021a","147":"e1dbda146ee024c88abe","251":"542f34a32675ac37e8d4","352":"a4836bc7bed5bc06a44f","631":"7f6481807ea5020ff807"}[chunkId] + ".js";
};